import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { IAccountsExportsApiRequest } from '../../../viewmodels/AdminViewModels';

export const useAdminAccountExportMutation = ({
	onError,
	onSuccess,
}: {
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (params: { request: IAccountsExportsApiRequest }) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'admin/account/export',
				}),
				'POST',
				params.request
			);
		},
		onError,
		onSuccess,
	});
};
